<template>
  <Catalog
    title="Маркетинговый источник"
    name-label="Название источника"
    description-label="Например: Сайт, Рекомендация, Холодный обзвон"
    submit-error="Укажите название маркетингового источника."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "MarketingSource",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getMarketingSourceById(id);
    },
    async putData(data) {
      return await this.putMarketingSource(data)
    },
    async postData(data) {
      return await this.postMarketingSource(data)
    },
    handleUpdateData(updatedItem) {
      this.newItem = updatedItem;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/MarketingSources/MarketingSource.vue